<template>
  <w-setting-sliding-popup ref="ipscanPopup" title="IP 대역" width="600px" @close="onClosePopup">
    <el-table-wrapper style="height: 100%;" slot="content" ref="ipscanTable" :data="ipscanList" :columns="columns" :pagination="false" :show-search-tool="false" :show-custom-header="true" />
  </w-setting-sliding-popup>
</template>

<script>
import { isEmpty } from '@/utils/basic';
import { EMPTY_TEXT } from '@/utils/string';
import DeviceRegistrationNmsAPI from '@/api/settings/common/device-registration-nms';

export default {
  name: 'WIpScanPopup',
  props: {
    scheduleData: Object,
  },
  data() {
    return {
      columns: [
        {
          prop: 'scanType',
          label: 'IP검색방법',
          headerAlign: 'center',
          formatter: this.convertScanType,
        },
        {
          prop: 'startAddress',
          label: '시작IP',
          headerAlign: 'center',
        },
        {
          prop: 'endAddress',
          label: '종료IP',
          headerAlign: 'center',
        },
        {
          label: '예외구간',
          headerAlign: 'center',
          childColumns: [
            {
              prop: 'exceptStartAddress',
              label: '예외시작IP',
              headerAlign: 'center',
            },
            {
              prop: 'exceptEndAddress',
              label: '예외종료IP',
              headerAlign: 'center',
            },
          ],
        },
      ],
      ipscanList: [],
    };
  },
  watch: {
    scheduleData() {
      this.loadData();
    },
  },
  methods: {
    /**
     * IP 대역 팝업창을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    open() {
      this.$refs.ipscanPopup.visible = true;
    },
    /**
     * IP 대역 팝업창을 닫는다.
     * @return {[type]} [description]
     * @author jda
     */
    onClosePopup() {
      this.$refs.ipscanPopup.visible = false;
      this.ipscanList = [];
    },
    /**
     * IP 검색 방법 formatter
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertScanType(row, column, value) {
      if (isEmpty(value)) {
        return EMPTY_TEXT;
      }

      if (value === 'SPOT') {
        return '단일 IP';
      } else if (value === 'RANGE') {
        return 'IP 구간';
      }
      return '서브넷마스크';
    },
    /**
     * IP 대역 데이터를 조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      DeviceRegistrationNmsAPI.getRegistMagicianInfo({ scheduleId: this.scheduleData.scheduleId }).then((response) => {
        if (response.data.success) {
          this.ipscanList = response.data.data.ipSearchList;
        } else {
          this.ipscanList = [];
        }
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/popup/IpScanPopup.vue